import { Component, Input } from '@angular/core';
import {
  NavController,
  NavParams,
  MenuController,
  AlertController,
  ModalController,
  Events,
  App
} from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ProfileServiceProvider } from '../../providers/profile-service/profile-service';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { UtilsServiceProvider } from '../../providers/utils-service/utils-service';
import { ToastServiceProvider } from '../../providers/toast-service/toast-service';
import { MessageFactory } from '../../app/factories/message.factory';
import { InterestsServiceProvider } from '../../providers/interests-service/interests-service';
import { LoaderServiceProvider } from '../../providers/loader-service/loader-service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'lubbu-profile',
  templateUrl: 'lubbu-profile.html'
})
export class LubbuProfileComponent {
  @Input() userId: string;
  @Input() isShowGotoHome: boolean;
  @Input() isFriendPage: boolean;
  @Input() itemId: string;

  public segment = 'asks';
  private lubbu: FormGroup;
  private pageAsk = 1;
  private pageFull = 1;
  private pageThanks = 1;
  public endOfList = {
    asks: false,
    gifts: false,
    thanks: false
  };
  private limit = 10;
  public items: any = [];
  public allItems: any;
  public filterType: any = 'asks';
  public profile: any = {};
  private user: any = {};
  interests;
  isFriend: boolean;
  isFirstFriend: boolean;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public menuCtrl: MenuController,
    public alertCtrl: AlertController,
    private formBuilder: FormBuilder,
    public profileService: ProfileServiceProvider,
    public requestService: RequestServiceProvider,
    public utilsService: UtilsServiceProvider,
    public toastService: ToastServiceProvider,
    public events: Events,
    public messageFactory: MessageFactory,
    private interestsService: InterestsServiceProvider,
    public loaderService: LoaderServiceProvider,
    private app: App
  ) {
    this.userId = navParams.get('profileId');
    this.itemId = navParams.get('fulfillmentId');

    this.lubbu = this.formBuilder.group({
      name: ['', Validators.required],
      note: [''],
      amount: ['']
    });

    this.isFriendPage = this.isFriendPage || false;

    this.events.subscribe('timeline-changed', event => {
      this.setSettingsEvents();
    });

    this.events.subscribe('fulfill-item', () => {
      this.setSettingsEvents();
    });

    this.events.subscribe('settings-changed', () => {
      this.getProfile();
      this.getInterests();
    });

    if (this.itemId) {
      this.segment = 'thanks';
      setTimeout(() => {
        let el = document.querySelector(
          `page-friend-profile lubbu-ask[id="${this.itemId}"]`
        );

        if (el) {
          el.scrollIntoView(true);
        }
      }, 1000);
    }
  }

  ngOnInit() {
    this.handlerUserFriends();
    this.getProfile();
    this.loadRequests();
    this.getInterests();
  }

  /**
   * User and friends handler
   *
   * @memberof LubbuProfileComponent
   */
  handlerUserFriends() {
    if (this.userId) {
      this.user.id = this.userId;
      this.getFriends();
    } else {
      this.user = this.profileService.getUser();
    }
  }

  /**
   * Get interests from api by user id
   *
   * @memberof LubbuProfileComponent
   */
  getInterests(): void {
    this.loaderService.showLoader();

    this.interestsService.getInterestsByUser(this.user.id).subscribe(
      data => {
        this.loaderService.dismissLoader();
        this.interests = data;
      },
      () => {
        this.loaderService.dismissLoader();
        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  /**
   * Get friends from api
   *
   * @memberof LubbuProfileComponent
   */
  getFriends(): void {
    this.loaderService.showLoader();
    this.requestService.getFriends().subscribe(
      data => {
        this.loaderService.dismissLoader();

        if (data.length) {
          this.isFirstFriend = false;
          this.isFriend = data.find(item => item.id === this.user.id);
        } else {
          this.isFirstFriend = true;
        }
      },
      () => {
        this.loaderService.dismissLoader();

        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  /**
   * Get profile from api
   *
   * @memberof LubbuProfileComponent
   */
  getProfile(): void {
    this.loaderService.showLoader();

    this.profileService.getUserById(this.user.id).subscribe(
      data => {
        this.profile = data;
        if (this.profile.picture) {
          this.profile.picture =
            this.profile.picture + `&time=${Math.floor(Math.random() * 10000)}`;
        }
        this.loaderService.dismissLoader();
      },
      () => {
        this.loaderService.dismissLoader();

        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  loadRequests(loading = true) {
    if (loading) {
      this.loaderService.showLoader();
    }

    forkJoin([
      this.requestService.getRequestsAskedByUserId(
        this.user.id,
        this.pageAsk,
        this.limit
      ),
      this.requestService.getRequestsFulfilledByUserId(
        this.user.id,
        this.pageFull,
        this.limit
      ),
      this.profileService.getRequestsThankedByUserId(
        this.user.id,
        this.pageThanks,
        this.limit
      )
    ]).subscribe(
      data => {
        if (loading) {
          this.loaderService.dismissLoader();
        }

        this.items.asks = data[0];
        this.items.gifts = data[1];
        this.items.thanks = data[2];

        // this.loadMessage();
        this.loadMessageFulfillment();
        this.loadMessageGivingFulfillment();
        this.setSegmentValue();
        this.allItems = Object.assign({}, this.items);
      },
      () => {
        if (loading) {
          this.loaderService.dismissLoader();
        }
        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  /**
   * Set segment values in each request
   *
   * @memberof LubbuProfileComponent
   */
  setSegmentValue() {
    this.items.asks.forEach(element => {
      element.segment = 'asks';
    });

    this.items.gifts.forEach(element => {
      element.segment = 'gifts';
    });

    this.items.thanks.forEach(element => {
      element.segment = 'thanks';
    });
  }

  loadMessage() {
    for (let item of this.items['thanks']) {
      if (item.requestOwnerName) {
        let name = item.requestOwnerName.split(' ')[0];
        if (name.substring(name.length - 1, 1).toUpperCase() == 'S') {
          name = name + "'";
        } else {
          name = name + "'s";
        }
        item.message = 'You have fulfilled ' + name + ' ask for';
      }
    }
  }

  loadMessageFulfillment() {
    for (let item of this.items['thanks']) {
      // item.message = `${item.fulfillerFullName} has fulfilled your ask for`;
      item.message = `${item.fulfillerFullName} to ${item.fullName}`;
    }
  }

  loadMessageGivingFulfillment() {
    for (let item of this.items['gifts']) {
      const name = this.isFriendPage ? `${item.fullName}'s` : 'your';

      item.message = `${item.fulfillerFullName} has lubbu'd ${name} ask for ${
        item.title
      } - ${item.comment}`;
    }
  }

  toggleFriend() {
    if (this.isFriend) {
      this.deleteFriend();
    } else {
      this.addFriend();
    }
  }

  /**
   * Delete friend from api
   *
   * @memberof LubbuProfileComponent
   */
  deleteFriend(): void {
    this.loaderService.showLoader();
    this.requestService.deleteFriend(this.user.id).subscribe(
      data => {
        this.loaderService.dismissLoader();
        this.isFriend = false;
        this.events.publish('friends-changed');
      },
      () => {
        this.loaderService.dismissLoader();

        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  /**
   * Add friend from api
   *
   * @memberof LubbuProfileComponent
   */
  addFriend(): void {
    this.loaderService.showLoader();
    this.requestService.addFriend(this.user.id).subscribe(
      data => {
        this.loaderService.dismissLoader();
        this.isFriend = true;
        let modal = this.modalCtrl.create(
          'ConfirmFriendModalPage',
          {
            isFirstFriend: this.isFirstFriend,
            user: this.profile
          },
          {
            cssClass: 'confirm-friend-modal'
          }
        );
        modal.present();
        this.events.publish('friends-changed');
      },
      () => {
        this.loaderService.dismissLoader();
        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  editProfile() {
    this.navCtrl.push('EditProfilePage');
  }

  /**
   * Go to Home page
   *
   * @memberof LubbuProfileComponent
   */
  gotoHome() {
    this.app.getRootNav().setRoot('TabsPage');
  }

  /**
   * Pagination for all segments
   *
   * @memberof LubbuProfileComponent
   */
  feed(): void {
    if (this.segment === 'asks') {
      this.pageAsk++;
      this.requestService
        .getRequestsAskedByUserId(this.user.id, this.pageAsk, this.limit)
        .subscribe(data => {
          if (!data.length) {
            this.endOfList.asks = true;
          }
          this.items.asks = this.items.asks.concat(data);
          this.setSegmentValue();
        });
    } else if (this.segment === 'gifts') {
      this.pageFull++;
      this.requestService
        .getRequestsFulfilledByUserId(this.user.id, this.pageFull, this.limit)
        .subscribe(data => {
          if (!data.length) {
            this.endOfList.gifts = true;
          }
          this.items.gifts = this.items.gifts.concat(data);
          this.setSegmentValue();
          this.loadMessageGivingFulfillment();
        });
    } else if (this.segment === 'thanks') {
      this.pageThanks++;
      this.profileService
        .getRequestsThankedByUserId(this.user.id, this.pageThanks, this.limit)
        .subscribe(data => {
          if (!data.length) {
            this.endOfList.thanks = true;
          }
          this.items.thanks = this.items.thanks.concat(data);
          this.setSegmentValue();
          this.loadMessageFulfillment();
        });
    }
  }

  /**
   * Pagination trigger
   *
   * @param {event} infiniteScroll
   * @memberof LubbuProfileComponent
   */
  doInfinite(infiniteScroll) {
    setTimeout(() => {
      this.feed();
      infiniteScroll.complete();
    }, 500);
  }

  /**
   * Set settings for reload events
   *
   * @memberof LubbuProfileComponent
   */
  setSettingsEvents() {
    this.pageAsk = 1;
    this.pageFull = 1;
    this.pageThanks = 1;
    this.items = [];
    this.endOfList = {
      asks: false,
      gifts: false,
      thanks: false
    };
    this.loadRequests(false);
  }
}



// WEBPACK FOOTER //
// ./src/components/lubbu-profile/lubbu-profile.ts